export default "__VITE_ASSET__189d7543__"